/* eslint-disable no-param-reassign,no-cond-assign */
export function isTouch() {
  return (typeof window !== 'undefined' && 'ontouchstart' in window);
}

export function hasClass(el, c) {
  return new RegExp(c).test(el.className);
}

export function addClass(el, c) {
  if (hasClass(el, c)) return;
  el.className += ` ${c}`;
}

export function removeClass(el, c) {
  el.className = el.className.replace(new RegExp(`${c}\\s?`), '');
}

export function toggleClass(el, c) {
  if (hasClass(el, c)) removeClass(el, c);
  else addClass(el, c);
}

let scrollBody;
export function getScrollBody() {
  if (scrollBody) return scrollBody;
  if (document.documentElement.scrollTop > 0) {
    scrollBody = window.$(document.documentElement);
  } else if (document.body.scrollTop > 0) {
    scrollBody = window.$(document.body);
  }
  return scrollBody || window.$('body,html');
}

export function getOffsetTop(el) {
  let t1;
  let t0;
  if (!el) return -1;
  t0 = el;
  t1 = el.offsetTop;
  while (t0 !== t0.offsetParent && (t0 = t0.offsetParent) !== null && t0.nodeName !== 'body' && t0) { t1 += t0.offsetTop; }
  return t1;
}

export function contParse(org) {
  if (!org) return '';
  return org.replace(/`([^`]+)`\(([^)]+)\)/g, '<a href="$2">$1</a>').replace(/\n/g, '<br>');
}



// WEBPACK FOOTER //
// ./src/util/index.js